import type { FC } from 'react';
import * as Styled from './styled';
import type { LoadingOverlayProps } from './types';

export * from './types';

export const LoadingOverlay: FC<LoadingOverlayProps> = (props) => {
  const { isLoading, transparent = false, ...rest } = props;

  if (!isLoading) return null;

  return (
    <Styled.Wrapper transparent={transparent}>
      <Styled.Loading color="dark" type="puff" />
    </Styled.Wrapper>
  );
};
